/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1LocationCountriesCountryidLangsId202,
  PutApiV1LocationCountriesCountryidLangsId400,
  PutApiV1LocationCountriesCountryidLangsId401,
  PutApiV1LocationCountriesCountryidLangsId404,
  PutApiV1LocationCountriesCountryidLangsId500,
  PutApiV1LocationCountriesCountryidLangsIdMutationRequest,
  PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
  PutApiV1LocationCountriesCountryidLangsIdPathParams,
} from "../../types/locationCountryLangController/PutApiV1LocationCountriesCountryidLangsId.ts";
import { countryLangViewModelSchema } from "../countryLangViewModelSchema.ts";
import { updateCountryLangRequestViewModelSchema } from "../updateCountryLangRequestViewModelSchema.ts";

export const putApiV1LocationCountriesCountryidLangsIdPathParamsSchema =
  z.object({
    countryId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1LocationCountriesCountryidLangsId202Schema = z.lazy(
  () => countryLangViewModelSchema,
) as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1LocationCountriesCountryidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1LocationCountriesCountryidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1LocationCountriesCountryidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1LocationCountriesCountryidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsId500>;

export const putApiV1LocationCountriesCountryidLangsIdMutationRequestSchema =
  z.lazy(
    () => updateCountryLangRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsIdMutationRequest>;

export const putApiV1LocationCountriesCountryidLangsIdMutationResponseSchema =
  z.lazy(
    () => putApiV1LocationCountriesCountryidLangsId202Schema,
  ) as unknown as ToZod<PutApiV1LocationCountriesCountryidLangsIdMutationResponse>;
